export default __webpack_public_path__ + "media/images/about/step-2.jpg";